angular.module('unica_tools.tools_services')

    .factory('ToolQrcodeService', function ($http, getBaseApiURL) {

        var toolService = {};

        toolService.generate = function (data)
        {
            return $http({
                method: 'POST',
                url: getBaseApiURL + '/tools/qrcode',
                data: data
            }).then(function(result) {

                if ( result.data.result == 'ok' ) {
                    return result.data.image;
                } else {
                    $rootScope.showWarningMsg( result.data.message );
                }

            });

        };

        return toolService;

    });